import { render, staticRenderFns } from "./mbInfrastructure.vue?vue&type=template&id=3830231e&scoped=true&"
import script from "./mbInfrastructure.vue?vue&type=script&lang=js&"
export * from "./mbInfrastructure.vue?vue&type=script&lang=js&"
import style0 from "./mbInfrastructure.vue?vue&type=style&index=0&id=3830231e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3830231e",
  null
  
)

export default component.exports